import React from "react";
import { Link } from "react-router-dom";
import styles from "./footer.module.scss";
// import Contact_Us_img from '../../assets/Contact Us.jpg' ;
// import whitelogo from "../../assets/millensys LOGO.png";
// import news_1 from '../../assets/news_1.png'
// import news_2 from '../../assets/news_2.jpg'
// import prod from '../../assets/New folder/1.jpg'
// import { Col  } from 'react-bootstrap' 
// import { FaWhatsapp } from "react-icons/fa";
// import { FaMobileAlt } from "react-icons/fa";
// import { FaPhoneAlt } from "react-icons/fa";
import millensys_profile from '../../../assets/PDF/millensys_profile.pdf';
import millensys_brochure_healthcare from '../../../assets/PDF/millensys_brochure_healthcare.pdf';
import millensys_brochure_ERP from '../../../assets/PDF/millensys_brochure_ERP.pdf';
import MSG from '../../../assets/new-banners/message.jpg'

import {
  // FaTwitter,
  FaFacebookF,
  FaLinkedinIn,
  // FaBlog,
  FaYoutube,
  FaInstagram,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
// import favicon_M from '../../assets/favicon_M.png'

const Footer = () => {
const whatsapp  = 'https://api.whatsapp.com/send?phone=201277773615' ;
  return (
    <section className={styles.footer_container}>
      <div className={styles.footer_container__content}>
        {/* <h1 className={styles.meg}>
          "at MILLENSYS, we code small, impactful innovations to create significant advancements in healthcare globally"
          <span  className={styles.favicon_M}><img src={favicon_M} alt="favicon_M" loading="lazy"/></span>
        </h1> */}
        <h1 className={styles.meg}>
          <img src={MSG} alt='message'   className={styles.msg} />
        </h1>
        <div className={styles.o_footer_columns}>
          <div>
            <h5 className={styles.footer__title}><Link to='/' className={styles.__a_list_link}>Company</Link></h5>
            <ul>
            <li>
                <a href={millensys_profile} download  className={styles.__a_list_link}>
                Company Profile
                </a>
              </li>

              <li>
                <a href={millensys_brochure_healthcare} download  className={styles.__a_list_link}>
                Healthcare Brochure
                </a>
              </li>
              <li>
                <a href={millensys_brochure_ERP} download  className={styles.__a_list_link}>
                ERP Brochure
                </a>
              </li>
              <li>
                <Link to='/products/32'   className={styles.__a_list_link}>
                Download MILLENSYS Free Software ( MiViewer)
                </Link>
              </li>
              <li>
                <Link to='/products/15'  className={styles.__a_list_link}>
                Download MILLENSYS Free Software ( Health Wallet)
                </Link>
              </li>
            </ul>
            {/* <h5 className={styles.footer__title_1}>MILLENSYS PACS is Best in KLAS in Middle East</h5>
            <h5 className={styles.footer__title}>
              <Link to='#' className={styles.__a_list_link}>
                <img src={news_1} alt='events' className='img-fluid'/>
                <img src={news_2} alt='events' className='img-fluid'/>
              </Link>
            </h5> */}
            {/* <p className={styles.news}>Vision Tools Workspace PACS rated best PACS in Middle Eas by KLAS for the second continoues year.</p> */}
          </div>
          {/* ------------------------------------------------------------ */}
          <div>
            <h5 className={styles.footer__title}><Link to='/Products' className={styles.__a_list_link}>Products</Link></h5>
            <ul>
              <li>
                <Link to='/products' className={styles.__a_list_link}>
                All Products
                </Link>
              </li>
              <li>
                <Link to='/products/products_healthcare' className={styles.__a_list_link}>
                Health-Care Products
                </Link>
              </li>
              <li>
                <Link to='/products/products_commercial' className={styles.__a_list_link}>
                Commercial Products
                </Link>
              </li>
              <a href="mailto:sales@millensys.com" className={`${styles["form-btn"]} ${styles.email} p-2 w-100 d-flex justify-content-center align-items-center`}>sales@millensys.com</a>
              <Link className={`${styles["form-btn"]} ${styles.email} p-2 w-100 d-flex justify-content-center align-items-center`}>+20 02 25627494</Link>
              <a href={whatsapp} className={`${styles["form-btn"]} ${styles.email} p-2 w-100 d-flex justify-content-center align-items-center`}>whatsapp | +20 127 777 3615</a>
            </ul>
            {/* <h5 className={styles.footer__title}>
              <Link to='/products/1' className={styles.__a_list_link}>
                <img src={prod} alt='products' className='img-fluid'/>
              </Link>
              UNIFIED E-HEALTH
            </h5> */}
          </div>
          {/*================================================================================= */}
          <div>
            <h5 className={styles.footer__title}>
              {/* <Link to='/' className={styles.__a_list_link}>
                <img src={whitelogo} alt='LOGO_img' className='img-fluid'/>
              </Link> */}
            </h5>
            <ul>
            <h5 className={styles.footer__title}><Link to='/about' className={styles.__a_list_link}>at Arab Health 2022 , Dubai</Link></h5>
              <li>
                <p className={styles.news}>
                for the latest unified eHealth solution including radiology , lab , pharmacy and home care solutions.
                </p>
              </li>

            <h5 className={styles.footer__title}><Link to='/about' className={styles.__a_list_link}>at RSNA 2019, Chicago</Link></h5>
              <li>
                <p className={styles.news}>
                Successful VNA / EMR Show at the American Congress of Radiology. .
                </p>
              </li>

            <h5 className={styles.footer__title}><Link to='/about' className={styles.__a_list_link}>at ECR 2018, Vienna</Link></h5>
              <li>
                <p className={styles.news}>
                Successful VNA / EHR Show at the European Congress of Radiology.
                </p>
              </li>
            </ul>
          </div>
          {/*================================================================================= */}
          <div>
            <h5 className={styles.footer__title}><Link to='/contact' className={styles.__a_list_link}>Contact Us</Link></h5>
            <h5 className={styles.footer__title}>
              {/* <Link to='/contact' className={styles.__a_list_link}>
                <img src={Contact_Us_img} alt='Contact_Us_img' className='img-fluid'/>
              </Link> */}
            </h5>
            <ul>
              <li>
                <Link to='/contact' className={styles.__a_list_link}>
                  Want To Be a MILLENSYS reseller ?
                </Link>
              </li>

              <li>
                <Link to='/order' className={styles.__a_list_link}>
                Request a Product Demo | Contact Sales
                </Link>
              </li>

              <li>
                <Link to='/support' className={styles.__a_list_link}>
                Request Online Support | Contact Support
                </Link>
              </li>
              {/* <div className={`${styles["socials-container"]} w-100 d-flex justify-content-between m-2`}>
                  <FaPhoneAlt className={`${styles.icon} fs-5`} />
                  <Col className={`text-center  text-white-50`} >+20 02 25627494</Col>
              </div> */}
                  {/*text-white-50 */}
              {/* <div className={`${styles["socials-container"]} w-100 d-flex justify-content-between m-2`}>
                  <FaWhatsapp className={`${styles.icon} fs-5`} onClick={()=>{window.open(whatsapp)}}/>
                  <Col className={`text-center text-white-50`} >+20 127 777 3615</Col>
              </div>       */}
              {/* <a href="mailto:sales@millensys.com" className={`${styles["form-btn"]} ${styles.email} p-2 w-100 d-flex justify-content-center align-items-center`}>sales@millensys.com</a> */}
              {/* <FaPhoneAlt className={`${styles.icon} fs-5`} /> */}
                {/* <span className={styles._contact} ></span> */}
                <Link className={`${styles["form-btn"]} ${styles.email} p-2 w-100 d-flex justify-content-center align-items-center`}>Hotline | +201117000311</Link>
                <a href="mailto:support@millensys.com" className={`${styles["form-btn"]} ${styles.email} p-2 w-100 d-flex justify-content-center align-items-center`}>Support | support@millensys.com</a>
                <a href="mailto:gulf.support@millensys.com" className={`${styles["form-btn"]} ${styles.email} p-2 w-100 d-flex justify-content-center align-items-center`}>Gulf area | gulf.support@millensys.com</a>
                <a href="mailto:americas.support@millensys.com" className={`${styles["form-btn"]} ${styles.email} p-2 w-100 d-flex justify-content-center align-items-center`}>North and South America | <br />americas.support@millensys.com</a>
            </ul>
          </div>
          {/*================================================================================= */}
        </div>

        <div className={styles.o_footer}>
          <div className={`${styles["socials-container"]} d-flex  m-2`}>
              <Link to='https://twitter.com/MILLENSYS1'target='_blank'><FaXTwitter className={`${styles.icon} fs-5`}/></Link>
              <Link
                to='http://www.facebook.com/millensys'
                target='_blank'
              >
                <FaFacebookF className={`${styles.icon} fs-5`}/>
              </Link>
            
          
              <Link
                to='http://www.linkedin.com/company/millensys-healthcare-technology'
                target='_blank'
              >
                <FaLinkedinIn className={`${styles.icon} fs-5`}/>
              </Link>
              <Link
                to='http://www.YouTube.com/@MILLENSYS'
                target='_blank'
              >
                <FaYoutube className={`${styles.icon} fs-5`} />
              </Link>
              <Link
                to='https://www.instagram.com/millensys'
                target='_blank'
              >
                <FaInstagram className={`${styles.icon} fs-5`} />
              </Link>
          </div>

          <div className={styles.o_footer__politics}>
            <ul className={styles.m_politics__list}>
              <li className={styles.a_list_item}>
                <Link to='/downloads' className={styles.a_list_link}>
                Downloads
                </Link>
              </li>
              <li className={styles.a_list_item}>
                <Link to='/careers' className={styles.a_list_link}>
                Careers
                </Link>
              </li>
              <li className={styles.a_list_item}>
                <Link to='/contact' className={styles.a_list_link_1}>
                    © {new Date().getFullYear().toString()} millensys Health. All rights reserved.
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
